import { render, staticRenderFns } from "./MenuEncabezado.vue?vue&type=template&id=6f732b8e&"
import script from "./MenuEncabezado.vue?vue&type=script&lang=js&"
export * from "./MenuEncabezado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports